var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#2A38A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7218 20.9718V17.0829C29.7218 12.2218 27.7773 10.2773 22.9162 10.2773H17.0829C12.2218 10.2773 10.2773 12.2218 10.2773 17.0829V22.9162C10.2773 27.7773 12.2218 29.7218 17.0829 29.7218H20.9718",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.457 22.4198L17.7709 19.4156C18.1015 18.9878 18.714 18.9101 19.1418 19.2406L20.9209 20.6406C21.3487 20.9712 21.9612 20.8934 22.2918 20.4754L24.5376 17.5781",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2707 23.7128L27.5429 24.2669C27.679 24.5391 28.0193 24.7919 28.3207 24.8503L28.6901 24.9086C29.7984 25.0933 30.0609 25.91 29.2637 26.7169L28.9234 27.0572C28.6998 27.2905 28.5735 27.7378 28.6415 28.0489L28.6901 28.253C28.9915 29.5947 28.2818 30.11 27.1151 29.41L26.8623 29.2641C26.5609 29.0891 26.0748 29.0891 25.7734 29.2641L25.5207 29.41C24.3443 30.1197 23.6345 29.5947 23.9457 28.253L23.9943 28.0489C24.0623 27.7378 23.9359 27.2905 23.7123 27.0572L23.3721 26.7169C22.5748 25.91 22.8373 25.0933 23.9457 24.9086L24.3151 24.8503C24.6068 24.8016 24.9568 24.5391 25.0929 24.2669L25.3651 23.7128C25.8901 22.653 26.7457 22.653 27.2707 23.7128Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.f278335b2a33aafc8a2ee183c241b635.svg";
export { ForwardRef as ReactComponent };